import { useScrollAnimation } from '../../../hooks/useScrollAnimation';

const reviews = [
  {
    text: 'データの正確性にびっくり！個室で友達と賑やかに過ごせました。',
    stars: 5,
  },
  {
    text: '解析が細かく1球ごとに修正表示。自主練に最適。毎日通いたくなりました！',
    stars: 5,
  },
  {
    text: '設備が清潔。シューズやクラブの無料レンタルも。のびのびゴルフを楽しめました！',
    stars: 5,
  },
  {
    text: '個室で気にせず楽しめた！データ正確で実践的。仕事終わりにも通えるのが嬉しい。',
    stars: 5,
  },
  {
    text: '体験利用。丁寧に教えてもらえて最初から最後まで楽しめました。大満足！',
    stars: 5,
  },
];

export default function Voice() {
  const { ref: noticeRef, isVisible: noticeVisible } = useScrollAnimation();
  const { ref: headRef, isVisible: headVisible } = useScrollAnimation();
  const { ref: cardsRef, isVisible: cardsVisible } = useScrollAnimation(0.05);

  return (
    <section id="voice" className="py-24 bg-[#fafafa]">

      {/* ── Notice ── */}
      <div
        ref={noticeRef}
        className={`px-6 lg:px-20 max-w-7xl mx-auto mb-16 transition-all duration-[700ms] ease-out ${noticeVisible ? 'opacity-100 translate-y-0 scale-100' : 'opacity-0 translate-y-14 scale-[0.97]'}`}
      >
        <div className="bg-[#fff8f6] border border-[#e85d2c]/20 rounded-2xl px-7 sm:px-10 py-8">
          <div className="flex items-center gap-3 mb-6">
            <div className="w-9 h-9 flex items-center justify-center rounded-full bg-[#e85d2c]/10 flex-shrink-0">
              <i className="ri-error-warning-line text-[#e85d2c] text-lg"></i>
            </div>
            <h3
              className="text-lg font-bold text-[#e85d2c]"
              style={{ fontFamily: "'Noto Serif JP', serif" }}
            >
              ご注意
            </h3>
          </div>
          <ul className="space-y-4">
            {[
              '身長が180cm以上の方が利用の際、スイングによっては、頭上の梁にクラブが接触する場合がございます。それに伴い、クラブの破損があった場合、お怪我をした際などの責任は負いかねますので、ご注意ください。',
              '当クラブの備品を破損、汚損した場合は、速やかにお申し出ください。監視カメラにより判明した場合、最寄りの警察署に提出させていただきます。',
              '過度に泥酔した状態での利用はお断りいたします。イベント時以外はアルコールの提供は致しません。',
              '機器破損などにより営業ができなくなった場合は、その間の営業補償を請求させていただくことがございます。',
              'ゴルフ保険などの加入をお勧めいたします。',
              'お申し込み時、ご予約時にご利用規約をよくお読みください。規約を守られない場合は法的な措置を取らさせていただく場合があります。',
            ].map((text, i) => (
              <li key={i} className="flex items-start gap-3">
                <span className="w-5 h-5 flex items-center justify-center rounded-full bg-[#e85d2c]/12 flex-shrink-0 mt-0.5">
                  <span className="text-[#e85d2c] text-[11px] font-bold">{i + 1}</span>
                </span>
                <p
                  className="text-[#1a1a3e]/65 text-[14px] leading-[1.85]"
                  style={{ wordBreak: 'auto-phrase' } as React.CSSProperties}
                >
                  {text}
                </p>
              </li>
            ))}
          </ul>
        </div>
      </div>

      {/* Heading */}
      <div
        ref={headRef}
        className={`px-6 lg:px-20 max-w-7xl mx-auto mb-12 text-center transition-all duration-[700ms] ease-out ${headVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-14'}`}
      >
        <h2
          className="text-3xl sm:text-4xl lg:text-5xl font-bold text-[#1a1a3e]"
          style={{ fontFamily: "'Noto Serif JP', serif", textWrap: 'balance', wordBreak: 'auto-phrase' } as React.CSSProperties}
        >
          ご利用者様の声。
        </h2>
        <p className="text-[#1a1a3e]/35 text-xs mt-4 flex items-center justify-center gap-1.5">
          <i className="ri-google-fill text-sm"></i>
          Google口コミより
        </p>
      </div>

      {/* Review cards — tile grid */}
      <div
        ref={cardsRef}
        className="px-6 lg:px-20 max-w-7xl mx-auto"
      >
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {reviews.map((r, i) => (
            <div
              key={i}
              className={`bg-white rounded-2xl p-7 border border-[#1a1a3e]/6 hover:border-[#47d6d4]/40 hover:-translate-y-1 transition-all duration-[550ms] flex flex-col ${
                cardsVisible ? 'opacity-100 translate-y-0 scale-100' : 'opacity-0 translate-y-14 scale-[0.92]'
              }`}
              style={{
                transitionDelay: `${i * 90}ms`,
                transitionTimingFunction: cardsVisible ? 'cubic-bezier(0.34, 1.45, 0.64, 1)' : 'ease-out',
              }}
            >
              <div className="flex items-center gap-0.5 mb-5">
                {Array.from({ length: r.stars }).map((_, si) => (
                  <i key={si} className="ri-star-fill text-[#e85d2c] text-sm"></i>
                ))}
              </div>
              <p className="text-[#1a1a3e]/65 text-[16px] leading-[1.8] flex-1">
                &ldquo;{r.text}&rdquo;
              </p>
              <div className="flex items-center gap-1.5 pt-5 mt-5 border-t border-[#1a1a3e]/6">
                <i className="ri-google-fill text-[#1a1a3e]/20 text-xs"></i>
                <span className="text-[#1a1a3e]/30 text-xs">Google口コミ</span>
              </div>
            </div>
          ))}

          {/* 6枚目: Googleビジネスプロフィール誘導タイル */}
          <a
            href="https://g.page/r/golph-club-suminoe/review"
            target="_blank"
            rel="noopener noreferrer"
            className={`group relative rounded-2xl p-7 border border-[#1a1a3e]/6 hover:border-[#e85d2c]/40 hover:-translate-y-1 transition-all duration-[550ms] flex flex-col items-center justify-center text-center overflow-hidden cursor-pointer ${
              cardsVisible ? 'opacity-100 translate-y-0 scale-100' : 'opacity-0 translate-y-14 scale-[0.92]'
            }`}
            style={{
              transitionDelay: `${reviews.length * 90}ms`,
              transitionTimingFunction: cardsVisible ? 'cubic-bezier(0.34, 1.45, 0.64, 1)' : 'ease-out',
              background: 'linear-gradient(135deg, #fff8f6 0%, #ffffff 60%, #f6fffe 100%)',
            }}
          >
            {/* 背景装飾 */}
            <div className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-500"
              style={{ background: 'radial-gradient(circle at 70% 30%, rgba(232,93,44,0.06) 0%, transparent 60%)' }}
            />

            {/* Googleロゴ風アイコン */}
            <div className="w-14 h-14 flex items-center justify-center rounded-full bg-white border border-[#1a1a3e]/8 mb-5 group-hover:scale-110 transition-transform duration-300">
              <i className="ri-google-fill text-2xl text-[#e85d2c]"></i>
            </div>

            {/* 星 */}
            <div className="flex items-center gap-0.5 mb-4">
              {Array.from({ length: 5 }).map((_, si) => (
                <i key={si} className="ri-star-fill text-[#e85d2c] text-sm"></i>
              ))}
            </div>

            <p
              className="text-[#1a1a3e] font-bold text-[15px] leading-[1.6] mb-2"
              style={{ fontFamily: "'Noto Serif JP', serif" }}
            >
              ご利用者様の声を<br />もっと見る
            </p>
            <p className="text-[#1a1a3e]/40 text-xs mb-6">
              Googleビジネスプロフィール
            </p>

            <span className="inline-flex items-center gap-1.5 text-[#e85d2c] text-xs font-medium border border-[#e85d2c]/30 rounded-full px-4 py-1.5 group-hover:bg-[#e85d2c] group-hover:text-white transition-all duration-300 whitespace-nowrap">
              口コミを見る
              <i className="ri-arrow-right-line text-xs"></i>
            </span>
          </a>
        </div>
      </div>
    </section>
  );
}
